/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { TransitionProps } from '@mui/material/transitions';
import { CircularProgress, Dialog, Slide } from '@mui/material';
import {
  formatText,
  getDefaultAlertProps,
  selectTheme,
} from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { LectionDivSlideItem } from '../lection/LectionDivSlideItem';
import { API_STATUS_PROBLEM, DARK_THEME } from '../../constant/constants';
import { LectionSlideDto } from '../../dto/LectionImageDto';
import { IApiResult } from '../../interface/IApiResult';
import { IAlertProps } from '../../interface/IAlertProps';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import classes from '../lection/LictionDiv.module.css';
import { apiGetCloudLections } from '../../service/apiGetCloudLections';

interface Props {
  id: string;
  curTheme: number;
  textColor: string;
  backgrounColor: string;
  open: boolean;
  fontSize: string;
  onClose: () => void;
}

const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>
    // eslint-disable-next-line react/jsx-props-no-spreading
  ) => <Slide direction="up" ref={ref} {...props} />
);

export const DialogCloud: FunctionComponent<Props> = ({
  id,
  curTheme,
  textColor,
  backgrounColor,
  open,
  fontSize,
  onClose,
}) => {
  const handleClose = () => {
    onClose();
  };

  const [lectionDtos, setLectionDtos] = useState<LectionSlideDto[]>([]);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  const getLections = async () => {
    const apiResult: IApiResult = await apiGetCloudLections(id);
    if (apiResult.isSuccess) {
      setLectionDtos(formatText(apiResult.data));
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  useEffect(() => {
    if (open) {
      getLections();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <div
      style={{
        userSelect: 'none',
        WebkitUserSelect: 'none',
        WebkitTextSizeAdjust: '100%',
      }}
    >
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <div
          style={{
            userSelect: 'none',
            background: selectTheme(
              '#FFFFFF;#1D2228',
              curTheme ?? DARK_THEME,
              -1
            ),
          }}
          className={classes.myDiv4}
        >
          <MyAlert
            message={alertProps.message}
            severity={alertProps.severity}
            onClose={() => setAlertProps({ ...alertProps, message: '' })}
          />
          {lectionDtos.length > 0 && (
            <LectionDivSlideItem
              isPopup
              dto={lectionDtos}
              themeFromMain={curTheme ?? DARK_THEME}
              selectPosition={-1}
              onChange={() => undefined}
              onChange2={() => undefined}
              onChange5={() => undefined}
              onClosePopus={onClose}
            />
          )}
          {!(lectionDtos.length > 0) && (
            <CircularProgress
              className={classes.divProgress}
              size={40}
              sx={{ color: '#00c7d3' }}
            />
          )}
        </div>
      </Dialog>
    </div>
  );
};
